import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  CreateFamsCustodianManagementPayload,
  FamsCustodianManagementItem,
  FamsCustodianManagementListParams,
  FamsCustodianManagementListResponse,
  UpdateFamsCustodianManagementPayload,
} from './types/custodian-management';

const request = createAppRequest();

export async function getFamsCustodianManagementList(
  params?: FamsCustodianManagementListParams,
  options?: ApiRequestOptions,
) {
  return request<FamsCustodianManagementListResponse>('/bff/fams/custodian-management/list', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function getFamsCustodianManagementDetail(
  id: number,
  options?: ApiRequestOptions,
) {
  return request<FamsCustodianManagementItem>(`/bff/fams/custodian-management/${id}`, {
    method: 'GET',
    ...(options || {}),
  });
}

export async function createFamsCustodianManagement(
  payload: CreateFamsCustodianManagementPayload,
  options?: ApiRequestOptions,
) {
  return request<FamsCustodianManagementItem>('/bff/fams/custodian-management', {
    method: 'POST',
    data: payload,
    ...(options || {}),
  });
}

export async function updateFamsCustodianManagement(
  id: number,
  payload: UpdateFamsCustodianManagementPayload,
  options?: ApiRequestOptions,
) {
  return request<FamsCustodianManagementItem>(`/bff/fams/custodian-management/${id}`, {
    method: 'PUT',
    data: payload,
    ...(options || {}),
  });
}

export async function updateFamsCustodianManagementState(
  id: number,
  state: number,
  options?: ApiRequestOptions,
) {
  return request<FamsCustodianManagementItem>(`/bff/fams/custodian-management/${id}/state`, {
    method: 'PATCH',
    data: { state },
    ...(options || {}),
  });
}
